import { useHandleEndLiveChat } from 'components/App/hooks/useHandleEndLiveChat';
import { Button } from '@forethought-technologies/forethought-elements';

export const RestartChatButton = () => {
  const handleEndLiveChat = useHandleEndLiveChat({
    /**
     * We don't want to send "User left the chat" message because it should've been
     * sent already when the end user ended the chat
     */
    shouldSendUserLeftMessage: false,
  });

  return (
    <Button onClick={handleEndLiveChat} variant='ghost'>
      Start new chat
    </Button>
  );
};
